// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"_3R5AHn"};